/** Shell-safe: only allow alphanumeric, hyphens, underscores, dots, colons, at-signs. */
export function sanitizeShellArg(value: string): string {
  const trimmed = value.trim();
  if (!/^[a-zA-Z0-9._:@\-]+$/.test(trimmed)) {
    throw new Error(`Invalid argument: "${trimmed}" contains disallowed characters`);
  }
  return trimmed;
}
